module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item active",
    attrs: {
      "role": "presentation"
    }
  }), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/consume"
    }
  }, [_vm._v("消費紀錄")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/personal"
    }
  }, [_vm._v("基本資料")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/performance"
    }
  }, [_vm._v("回饋金查詢")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/bonus"
    }
  }, [_vm._v("領取紀錄")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/order"
    }
  }, [_vm._v("訂購紀錄")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/redeen"
    }
  }, [_vm._v("抵用券")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/team"
    }
  }, [_vm._v("組織查詢")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/training"
    }
  }, [_vm._v("會員權益與培訓")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/share"
    }
  }, [_vm._v("分享網址")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/transfer"
    }
  }, [_vm._v("申請移轉")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/member/agreement"
    }
  }, [_vm._v("合約中心")])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/member"
    }
  }, [_vm._v("會員中心")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("基本資料")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25983a82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/Member.vue
// module id = 293
// module chunks = 1